<ais-instant-search
    :index-name="indexName"
    :search-client="searchClient"
    :routing="routing"
>
    <tzo-search />
</ais-instant-search>
